/* eslint-disable rover/no-platform-specific-globals-or-imports */
// @flow
import $ from '@rover/globals/jquery';

import EmbeddedEventStrategy from './embeddedEventStrategy';

export default class CordovaEmbeddedEventStrategy extends EmbeddedEventStrategy {
  // The Cordova interface is deprecated and will be removed
  // Please do not add to this list; prefer rover-context-based message handlers, e.g. rover.postMessage
  static CORDOVA_EVENTS = [
    'dialog-closed',
    'set-mobile-action',
    'enable-mobile-action',
    'hide-loading-indicator',
    'show-loading-indicator',
  ];

  static handlesEvent(eventName: string, { isAndroid }: { isAndroid: boolean }): boolean {
    const documentExists = !!document;
    const eventIsHandled = CordovaEmbeddedEventStrategy.CORDOVA_EVENTS.includes(eventName);
    return isAndroid && documentExists && eventIsHandled;
  }

  triggerEvent(eventName: string): void {
    try {
      const eventData = { type: eventName };
      $(document).trigger(eventData);
    } catch (e) {
      this.errorHandler(e);
    }
  }
}



// WEBPACK FOOTER //
// ../utilities/embedded/cordovaEmbeddedEventStrategy.js